export default function ContactSection() {
  return (
    <section id="contact" className="section-padding bg-background-50">
      <div className="section-container">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            投稿联系
          </h2>
          <p className="text-foreground-600 mt-3 text-sm md:text-base leading-relaxed">
            如果你有原创漫画作品希望与甜柚漫画合作，或者对平台有任何建议和反馈，
            欢迎通过以下方式联系我们。我们珍视每一位创作者和读者的声音。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-bold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              投稿合作
            </a>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium whitespace-nowrap hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <i className="ri-feedback-line"></i>
              意见反馈
            </a>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6 mt-6 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-mail-line text-primary-400"></i> contact@tianyoumanga.com
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-wechat-line text-primary-400"></i> 甜柚漫画官方
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-weibo-line text-primary-400"></i> @甜柚漫画
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}